// extracted by mini-css-extract-plugin
export var childrenContent = "bR_fX";
export var content = "bR_V";
export var titleContent = "bR_fY";
export var titleContentLabel = "bR_fZ";